export default "__VITE_ASSET__91551d08__"